<template lang="pug">
#sub-empresa-bloco-inserir-codigo-externo
    el-dialog(
        :title='tituloModal',
        :visible.sync='dialogVisible',
        :before-close='fechar',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        width='60%'
    )
        el-form(
            label-position='top',
            :model='formCodigoExterno',
            :rules='formCadastroCodigoRegras',
            ref='formCadastroCodigoRef'
        )
            el-form-item(prop='codigoExternoInput')
                el-input(
                    maxlength='100',
                    v-model.string='formCodigoExterno.codigoExternoInput'
                )
        span(slot='footer')
            el-button(@click='fechar') {{ this.$t('mensagens.subEmpresaGestao.blocoInserirCodigoExterno.cancelar') }}
            el-button(type='primary', @click.prevent='inserirCodigoExterno()') {{ this.$t('mensagens.subEmpresaGestao.blocoInserirCodigoExterno.salvar') }}
</template>

<script>
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';

export default {
    name: 'SubEmpresaBlocoInserirCodigoExterno',

    emits: ['fechar', 'verificarConcluir'],

    components: {
        ContratoOriginacaoServiceSubEmpresa
    },

    props: {
        dados: {
            required: true,
            type: Object
        },
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        }
    },

    data() {
        const validarNumeroContrato = (rule, value, callback) => {
            if (!value || value.toString().length > 100) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.numeroCaracteres'
                        )
                    )
                );
                return;
            }

            const apenasLetrasNumeros = /^[0-9a-zA-Z\b]+$/g;
            if (!apenasLetrasNumeros.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.apenasLetrasNumeros'
                        )
                    )
                );
                return;
            }
            callback();
        };

        return {
            tituloModal: this.$t(
                'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.cadastrarCodigo'
            ),
            formCadastroCodigoRegras: {
                codigoExternoInput: [
                    {
                        required: true,
                        validator: validarNumeroContrato,
                        trigger: 'blur'
                    }
                ]
            },
            formCodigoExterno: {
                codigoExternoInput: ''
            }
        };
    },

    mounted() {
        this.formCodigoExterno.codigoExternoInput = this.dados.codigoExterno;
        if (this.dados.codigoExterno) {
            this.tituloModal = this.$t(
                'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.editarCodigo'
            );
        }
    },

    methods: {
        async inserirCodigoExterno() {
            this.$refs['formCadastroCodigoRef'].validate(valid => {
                if (valid) {
                    const contrato = {
                        codigoExterno:
                            this.formCodigoExterno.codigoExternoInput,
                        numeroContrato: this.dados.numeroContrato
                    };

                    ContratoOriginacaoServiceSubEmpresa.inserirCodigoExterno(
                        contrato
                    )
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.salvoSucesso'
                                )
                            );

                            this.$emit('fechar', false);
                            this.$emit('verificarConcluir', true);
                            this.dados.codigoExterno =
                                this.formCodigoExterno.codigoExternoInput;
                        })
                        .catch(() => {
                            this.$notify.error({
                                message: this.$t(
                                    'mensagens.subEmpresaGestao.blocoInserirCodigoExterno.erroInserirCodigo'
                                )
                            });
                        });
                }
            });
        },

        fechar() {
            this.formCodigoExterno.codigoExternoInput = '';
            this.$emit('fechar', false);
            this.$refs['formCadastroCodigoRef'].resetFields();
        }
    }
};
</script>

<style lang="scss" scoped>
#sub-empresa-bloco-inserir-codigo-externo {
}
</style>
